import { Routes, Route } from 'react-router-dom';
import { Suspense, lazy } from 'react';
import { AuthProvider } from '@/context/AuthContext';
import { SmoothScrollProvider } from '@/components/common/SmoothScrollProvider';

// Layouts
import PublicLayout from '@/components/layout/PublicLayout';
import AdminLayout from '@/components/layout/AdminLayout';

// Public pages
const Home = lazy(() => import('@/pages/public/Home'));
const About = lazy(() => import('@/pages/public/About'));
const Services = lazy(() => import('@/pages/public/Services'));
const ServiceDetail = lazy(() => import('@/pages/public/ServiceDetail'));
// HIDDEN UNTIL LAUNCH
// const Investors = lazy(() => import('@/pages/public/Investors'));
// const Contact = lazy(() => import('@/pages/public/Contact')); // REMOVED — form is in footer
const LegalPage = lazy(() => import('@/pages/public/LegalPage'));
// const Careers = lazy(() => import('@/pages/public/Careers')); // REMOVED
const Privacy = lazy(() => import('@/pages/public/Privacy'));
const Terms = lazy(() => import('@/pages/public/Terms'));
// const CompanyInfo = lazy(() => import('@/pages/public/CompanyInfo')); // REMOVED
const Cookies = lazy(() => import('@/pages/public/Cookies'));
const NotFound = lazy(() => import('@/pages/public/NotFound'));

// Admin pages
const AdminLogin = lazy(() => import('@/pages/admin/Login'));
const Dashboard = lazy(() => import('@/pages/admin/Dashboard'));
const ProjectsManager = lazy(() => import('@/pages/admin/ProjectsManager'));
const ProjectEditor = lazy(() => import('@/pages/admin/ProjectEditor'));
const PagesManager = lazy(() => import('@/pages/admin/PagesManager'));
const PageEditor = lazy(() => import('@/pages/admin/PageEditor'));
const MediaLibrary = lazy(() => import('@/pages/admin/MediaLibrary'));
const ContactSubmissions = lazy(() => import('@/pages/admin/ContactSubmissions'));
const Settings = lazy(() => import('@/pages/admin/Settings'));
const Users = lazy(() => import('@/pages/admin/Users'));
const AIProfiles = lazy(() => import('@/pages/admin/AIProfiles'));

function LoadingSpinner() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-paper">
      <div className="flex flex-col items-center gap-4">
        <div className="w-12 h-12 border-4 border-gold border-t-transparent rounded-full animate-spin" />
        <p className="text-ink-muted">Loading...</p>
      </div>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <SmoothScrollProvider>
        <Suspense fallback={<LoadingSpinner />}>
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<PublicLayout />}>
              <Route index element={<Home />} />
              <Route path="about" element={<Services />} />
              <Route path="services" element={<Services />} />
              <Route path="services/:service" element={<ServiceDetail />} />
              {/* HIDDEN UNTIL LAUNCH - Investors route removed */}
              {/* <Route path="contact" element={<Contact />} /> REMOVED — form is in footer */}
              {/* <Route path="careers" element={<Careers />} /> REMOVED */}
              <Route path="privacy" element={<Privacy />} />
              <Route path="terms" element={<Terms />} />
              {/* <Route path="company" element={<CompanyInfo />} /> REMOVED */}
              <Route path="cookies" element={<Cookies />} />
              <Route path="legal/:slug" element={<LegalPage />} />
              <Route path="*" element={<NotFound />} />
            </Route>

            {/* Admin Routes */}
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="projects" element={<ProjectsManager />} />
              <Route path="projects/new" element={<ProjectEditor />} />
              <Route path="projects/:id/edit" element={<ProjectEditor />} />
              <Route path="pages" element={<PagesManager />} />
              <Route path="pages/new" element={<PageEditor />} />
              <Route path="pages/:id/edit" element={<PageEditor />} />
              <Route path="media" element={<MediaLibrary />} />
              <Route path="messages" element={<ContactSubmissions />} />
              <Route path="ai-profiles" element={<AIProfiles />} />
              <Route path="settings" element={<Settings />} />
              <Route path="users" element={<Users />} />
            </Route>
          </Routes>
        </Suspense>
      </SmoothScrollProvider>
    </AuthProvider>
  );
}

export default App;
